import DashboardHome from './sections/DashboardHome';
import Revenus from './sections/Revenus';
import Chaine from './sections/Chaine';
import Formation from './sections/Formation';
import Taches from './sections/Taches';
import Retraits from './sections/Retraits';
import Profil from './sections/Profil';
import RoueChance from './sections/RoueChance';
import Contacts from './sections/Contacts';
import ApkPremium from './sections/ApkPremium';
import APropos from './sections/APropos';
import ServiceClient from './sections/ServiceClient';
import FilleulsTableau from './sections/FilleulsTableau';

interface DashboardContentProps {
  currentSection: string;
  setIsSidebarOpen: (isOpen: boolean) => void;
  currentUser: any;
}

const sectionTitles: Record<string, string> = {
  dashboard:        'Tableau de bord',
  revenus:          'Mes revenus',
  filleuls:         'Mes filleuls',
  chaine:           'Ma chaîne',
  formation:        'Formation',
  taches:           'Toutes les tâches',
  retraits:         'Retraits',
  profil:           'Mon profil',
  roue:             'Roue de chance',
  contacts:         'Contacts VCF',
  apk:              'APK Premium',
  apropos:          'À propos de nous',
  'service-client': 'Service Client',
};

export default function DashboardContent({ currentSection, setIsSidebarOpen, currentUser }: DashboardContentProps) {
  return (
    <div className="flex flex-col min-h-screen w-full bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-30 shadow-sm flex-shrink-0">
        <div className="px-4 lg:px-6 h-14 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setIsSidebarOpen(true)}
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 cursor-pointer transition-colors"
            >
              <i className="ri-menu-line text-xl text-gray-700"></i>
            </button>
            <h1 className="text-base font-bold text-gray-800 hidden sm:block">
              {sectionTitles[currentSection] ?? 'Tableau de bord'}
            </h1>
          </div>
          <div className="flex items-center gap-2">
            <button className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 cursor-pointer relative transition-colors">
              <i className="ri-notification-3-line text-lg text-gray-600"></i>
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white"></span>
            </button>
          </div>
        </div>
      </header>

      {/* Contenu */}
      <main className="flex-1 p-4 lg:p-6 overflow-auto animate-fadeIn">
        {currentSection === 'dashboard'      && <DashboardHome currentUser={currentUser} />}
        {currentSection === 'revenus'        && <Revenus currentUser={currentUser} />}
        {currentSection === 'filleuls'       && <FilleulsTableau currentUser={currentUser} />}
        {currentSection === 'chaine'         && <Chaine currentUser={currentUser} />}
        {currentSection === 'formation'      && <Formation />}
        {currentSection === 'taches'         && <Taches currentUser={currentUser} />}
        {currentSection === 'retraits'       && <Retraits currentUser={currentUser} />}
        {currentSection === 'profil'         && <Profil currentUser={currentUser} />}
        {currentSection === 'roue'           && <RoueChance />}
        {currentSection === 'contacts'       && <Contacts />}
        {currentSection === 'apk'            && <ApkPremium />}
        {currentSection === 'apropos'        && <APropos />}
        {currentSection === 'service-client' && <ServiceClient currentUser={currentUser} />}
      </main>
    </div>
  );
}